import axiosCall from './interceptor';
import URL from '../helper';

export const getAllCategories = async (includeElements = false, categoryType = 'element') => {
  const url = `${URL.BASE_URL}category?includeElements=${includeElements}&type=${categoryType}`;
  let response = await axiosCall('get', url);
  return response.data;
};

export const getAllDocumentsByCategories = async (includePages = false, hasCount = true, type, isPublished = false,accessType, cancelTokenSource) => {
  let url = `${URL.DESIGN_SYSTEM_URL}dynamic/documentByCategory?includeFlows=${includePages}&includeVariables=${includePages}&${accessType && `rgpermission=${accessType}`}`;
  if (hasCount) {
    url = `${URL.DESIGN_SYSTEM_URL}dynamic/documentByCategory?includeFlows=${includePages}&includeVariables=${includePages}&countPerCategory=4`;
  }
  if(isPublished) {
    url = `${URL.TRANSACTION_SYSTEM_URL}publishDocumentByCategory?includeFlows=${includePages}&includeVariables=${includePages}&countPerCategory=4`;
  }
  let response = await axiosCall('get', url,{cancelToken : cancelTokenSource?.token});
  return response.data;
}

export const getAllCategoriesByShortMessageTemplate = async (includePages = false, hasCount = true, type, isPublished = false,accessType) => {
  const statusUrl = isPublished ? 'publishedmessagebycategory' : 'messagebycategory';
  let url = `${URL.BASE_URL}${statusUrl}?includePages=${includePages}&includeVariables=${includePages}&${accessType && `rgpermission=${accessType}`}`;
  if (hasCount) {
    url = `${URL.BASE_URL}${statusUrl}?includePages=${includePages}&includeVariables=${includePages}&countPerCategory=4`;
  }
  if (isPublished) {
    url = `${url}&rgpermission=write`
  }
  if (type) {
    url = `${url}&type=${type}`;
  }
  let response = await axiosCall('get', url);
  return response.data;
};

export const createCategory = async data => {
  const url = `${URL.BASE_URL}category`;
  let response = await axiosCall('post', url, data);
  return response.data;
};

export const updateCategory = async data => {
  const url = `${URL.BASE_URL}category`;
  let response = await axiosCall('put', url, data);
  return response.data;
};

export const deleteCategory = async payload => {
  const url = `${URL.BASE_URL}category?id=${payload.id}`;
  let response = await axiosCall('delete', url);
  return response.data;
};

export const getMasterCategory = async () => {
  const url = `${URL.BASE_URL}masterCategory`;
  let response = await axiosCall('get', url);
  return response.data;
}
